class YourMap {

    constructor() {
        this.initYourMapObject();

        this.accessToken = 'pk.eyJ1Ijoic2thaSIsImEiOiJjajVsZ2lnaWcyZml5MzFsbWh3Nnk1ZmUzIn0.okIp_Sj1OHS6EZqlS3thPg';
        this.loaderClass = '#map-holder .loader-spinner';
        this.container = 'map';
        this.style = yourMap.style;
        this.center = yourMap.center;
        this.zoom = yourMap.zoom;
        this.maxZoom = 15;
        this.scrollZoom = true;
        this.mapObject = null;
        
        // mapboxgl is set up as a global in globals.js
        if (typeof mapboxgl === 'undefined') {
            console.error('mapboxgl is not loaded. Make sure editor/globals.js is imported first.');
            throw new Error('mapboxgl is not available');
        }
        mapboxgl.accessToken = this.accessToken;
    }

    init () {
        this.showLoader();
        this.create();
        this.removeExtraElements();
    }

    initYourMapObject () {
        let yourMapStored = Cookies.get(localDataID);
        if (yourMapStored !== undefined) {
            yourMapStored = JSON.parse(yourMapStored);
            yourMap = Object.assign({}, yourMap, yourMapStored);
        }
    }

    showLoader() {
        $(this.loaderClass).show();
    }

    hideLoader() {
        $(this.loaderClass).hide();
    }

    create() {
        this.mapObject = new mapboxgl.Map({
            container: this.container,
            style: this.style,
            center: this.center,
            zoom: this.zoom,
            maxZoom: this.maxZoom,
            scrollZoom: this.scrollZoom,
            preserveDrawingBuffer: true //TODO: it is a performance isssue. Should be reworked and moved to backend.
        });

        // disable map rotation using right click + drag
        this.mapObject.dragRotate.disable();

        // disable map rotation using touch rotation gesture
        this.mapObject.touchZoomRotate.disableRotation();

        const control = new mapboxgl.NavigationControl({ showCompass: false });

        // TODO: create a proper container for controls.
        document.querySelector('.map-wrap').appendChild(control.onAdd(this.mapObject));

        // TODO: move to a separate event method
        this.mapObject.on('zoomend', (e)=> {
            updateYourMapObject({ zoom: this.mapObject.getZoom() })
        });

        this.mapObject.on('load', (e)=> {
            this.scale();
            this.hideLoader();
        });

        this.mapObject.on('dblclick', (e)=> {
            e.preventDefault();
            const event = new Event('click');
            control._zoomInButton.dispatchEvent(event);
        });

    }

    scale() {
        $('#map').css({
            opacity: 1
        });
    }

    removeExtraElements() {
        $('.mapboxgl-ctrl-logo').remove();
        $('.mapboxgl-ctrl.mapboxgl-ctrl-attrib').remove();
    }

    getMapCenter(){
        const center = this.mapObject.getCenter();
        return [ center.lng, center.lat ];
    }

    createRoute(settings){
        this.deleteLayer(settings.prevRouteId);
        if(settings.enableFitToTheBounds) {
            this.fitToTheBounds(settings.bounds);
        }
        this.setLineLayer(settings);
    }

    deleteLayer(routeId){
        if(this.isLayerExist(routeId)) {
            this.mapObject.removeLayer(routeId).removeSource(routeId);
        }
    }

    setRouteColor({routeId, routeColor }) {
        if(this.isLayerExist(routeId)){
            this.mapObject.setPaintProperty(routeId, 'line-color', routeColor);
        }
    }

    setRouteWidth({routeId, routeWidth }) {
        if(this.isLayerExist(routeId)){
            this.mapObject.setPaintProperty(routeId, 'line-width', routeWidth);
        }
    }

    isLayerExist(id){
        return !!this.mapObject.getLayer(id);
    }

    fitToTheBounds(bounds){
        this.mapObject.fitBounds( bounds, {
            padding: {
                top: 50,
                bottom: 300, //because map goes below legend we need to have bigger bottom padding
                right:50,
                left: 50
            },
            duration: 0
        });
    }

    setLineLayer({ routeId, geoJson, routeColor, routeWidth }){
        this.mapObject.addLayer({
            id: routeId,
            type: 'line',
            source: {
                type: 'geojson',
                data: geoJson
            },
            layout: {
                'line-join': 'round',
                'line-cap': 'round'
            },
            paint: {
                'line-color': routeColor,
                'line-width': routeWidth
            }
        });
    }

}

export default YourMap;
